import usePricesSocket from "@shared/services/socket/usePricesSocket";
import { useEffect, useMemo } from "react";
import {
  GetTradeExtraInfoOrdersGraphRequest,
  GetTradesRequest,
  LineChartDataPointWithExchange,
  PriceGraphDataRequest,
  RawLineChartDataPoint,
  TimeRange,
} from "@shared/types";
import { useDispatch } from "react-redux";
import { updateGraphData } from "@shared/utils/charts";

export type GraphDataPointTypes =
  | LineChartDataPointWithExchange
  | RawLineChartDataPoint;

const useLiveGraphData = <GraphDataPointType extends GraphDataPointTypes>(
  service: any,
  endpointName: any,
  getGraphDataArgs:
    | PriceGraphDataRequest
    | GetTradeExtraInfoOrdersGraphRequest
    | GetTradesRequest
    | undefined,
  timeRange: TimeRange,
  symbol?: string,
  exchange?: string,
  isGraphDataWithExchange?: boolean
) => {
  const { socketPrice } = usePricesSocket(symbol, exchange);
  const socketPriceValue = socketPrice.value;
  const currentTimestamp = Date.now() / 1000;
  const dispatch = useDispatch();

  const getNewPoint = () => {
    if (socketPriceValue) {
      if (isGraphDataWithExchange && exchange) {
        return <GraphDataPointType>[
          currentTimestamp,
          exchange,
          socketPriceValue,
        ];
      } else {
        return <GraphDataPointType>[currentTimestamp, socketPriceValue];
      }
    }
  };

  const newPoint = useMemo(() => getNewPoint(), [socketPrice]);

  useEffect(() => {
    if (newPoint && getGraphDataArgs) {
      dispatch(
        updateGraphData(
          service,
          endpointName,
          getGraphDataArgs,
          timeRange,
          currentTimestamp,
          newPoint
        )
      );
    }
  }, [newPoint]);
};

export default useLiveGraphData;
